<template>
    <!-- 阻止点击事件冒泡 -->
    <div @click.stop>
        <div class="license-wrap">
            <!-- 车牌号类型选择 -->
            <div class="radio-box bh bend fz_30">
                <div class="b1 tl">车牌号：</div>
                <van-radio-group icon-size="16" v-model="commonCard" class="bh bc">
                    <van-radio name="1" class="mr_10">普通车牌</van-radio>
                    <van-radio name="2">新能源车牌</van-radio>
                </van-radio-group>
            </div>
            <!-- 车牌号输入框 -->
            <div class="bh bbetween num-box">
                <!-- 第一个省份输入框 -->
                <van-button
                    class="btn-num btn-keyboard"
                    :class="activeKeyWordIndex==0?'select':''"
                    @click="inputCarNum(0)"
                >{{numArr[0]}}</van-button>
                <!-- 第二个字母输入框 -->
                <van-button
                    class="btn-num btn-keyboard"
                    :class="activeKeyWordIndex==1?'select':''"
                    @click="inputCarNum(1)"
                >{{numArr[1]}}</van-button>
                <!-- 分割圆点 -->
                <em class="spot radius"></em>
                <!-- 后续第三到第七位号码 -->
                <van-button
                    class="btn-num btn-keyboard"
                    :class="activeKeyWordIndex==item?'select':''"
                    @click="inputCarNum(item)"
                    v-for="(item,index) in inputNum"
                    :key="index"
                >{{numArr[item]}}</van-button>
                <!-- 第八位号码  是否新能源？ -->
                <van-button
                    v-show="isNewEnergy"
                    class="btn-num btn-keyboard"
                    :class="activeKeyWordIndex==7?'select':''"
                    @click="inputCarNum(7)"
                >{{numArr[7]}}</van-button>
            </div>
        </div>
        <!-- 输入键盘 -->
        <div class="keyboard-license-wrap" v-if="isKeyBoard">
            <!-- 完成按钮 -->
            <van-button @click="hidden" class="fz_30 btn-keyWin bg-contain"></van-button>
            <!-- 第一位汉字键盘 -->
            <div class="text-container" v-if="isText">
                <div class="first-word bh bc" v-for="(item,index) in firstKey" :key="index">
                    <van-button
                        v-for="(item,index) in item"
                        :key="index"
                        class="btn btn-keyboard"
                        @click="clickKeyBoard(item,true)"
                    >{{ item }}</van-button>
                    <!-- 删除按钮 -->
                    <van-button
                        @touchstart="deleteWord"
                        class="btn btn-keyboard delete"
                        v-if="(firstKey.length-1)==index"
                    ></van-button>
                </div>
            </div>
            <!-- 数字键盘 -->
            <div class="letter-container" v-if="isLetter">
                <div class="keyboard bh bc">
                    <van-button
                        class="btn btn-keyboard"
                        :disabled="!isNum"
                        v-for="(item,index) in numKey"
                        :key="index"
                        @touchstart="clickKeyBoard(item, isNum)"
                    >{{item}}</van-button>
                </div>
                <!-- 字母键盘 -->
                <div class="bh bc" v-for="(item,index) in letterKey" :key="index">
                    <van-button
                        class="btn btn-keyboard"
                        v-for="(item,index) in item"
                        :key="index"
                        @touchstart="clickKeyBoard(item,true)"
                    >
                        <div class="fz_30">{{item}}</div>
                    </van-button>
                    <!-- 删除按钮 -->
                    <van-button
                        class="btn btn-keyboard delete"
                        v-if="(letterKey.length-1)==index"
                        @touchstart="deleteWord"
                    ></van-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    model: {
        // 绑定的值，通过父组件传递
        prop: "value",
        // 自定义事件名
        event: "update"
    },
    props: {
        // 暴露给父组件
        // 用于v-model绑定值
        // 车牌号码
        value: { default: "" }
    },
    data() {
        return {
            // 是否内部调整值
            isChange: false,
            // 是否通过验证
            isverify: false,
            // 当前输入数组值
            numArr: ["", "", "", "", "", "", "", ""],
            // 输入框遍历
            inputNum: [2, 3, 4, 5, 6],
            // 车牌类型
            commonCard: "1",
            firstKey: [
                ["京", "湘", "津", "鄂", "沪", "粤", "渝", "琼", "翼"],
                ["川", "晋", "贵", "辽", "云", "吉", "陕", "黑", "甘"],
                ["苏", "青", "浙", "皖", "藏", "闽", "蒙"],
                ["赣", "桂", "鲁", "宁", "豫", "新"]
            ],
            numKey: [1, 2, 3, 4, 5, 6, 7, 8, 9, 0],
            letterKey: [
                ["Q", "W", "E", "R", "T", "Y", "U", "P"],
                ["A", "S", "D", "F", "G", "H", "J", "K", "L"],
                ["Z", "X", "C", "V", "B", "N", "M"]
            ],
            // 当前定位位置
            activeKeyWordIndex: 0,
            // 是否显示键盘
            isKeyBoard: false,
            // 旧车牌校验规则：
            // 车牌号格式：汉字 + A-Z + 5位A-Z或0-9（车牌号不存在字母I和O防止和1、0混淆）
            // （只包括了普通车牌号，教练车，警等车牌号 。部分部队车，新能源不包括在内）
            // 京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼军空海北沈兰济南广成使领
            oldRegular: /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/,
            // 新能源校验规则
            // 组成：省份简称（1位汉字）+发牌机关代号（1位字母）+序号（6位），总计8个字符，序号不能出现字母I和字母O
            // 通用规则：不区分大小写，第一位：省份简称（1位汉字），第二位：发牌机关代号（1位字母）
            // 序号位：
            // 小型车，第一位：只能用字母D或字母F，第二位：字母或者数字，后四位：必须使用数字
            // ---([DF][A-HJ-NP-Z0-9][0-9]{4})
            // 大型车，前五位：必须使用数字，第六位：只能用字母D或字母F。
            // ----([0-9]{5}[DF])
            newRegular: /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF])|([DF][A-HJ-NP-Z0-9][0-9]{4}))$/
        };
    },
    watch: {
        // 输入值改变
        numArr() {
            this.checkValue();
        },
        // 是否新能源
        isNewEnergy(v) {
            if (!v) {
                this.setKeyValue("", 7);
            } else {
                this.checkValue();
            }
        },
        // 监听值改变
        value(v) {
            this.setValue(v);
        },
        // 键盘输入状态改变
        isKeyBoard(v) {
            if (!v) {
                // 输入键盘隐藏时隐藏光标
                this.activeKeyWordIndex = -1;
            }
        }
    },
    computed: {
        isLetter() {
            return this.activeKeyWordIndex > 0;
        },
        // 是否显示文字输入
        isText() {
            return this.activeKeyWordIndex == 0;
        },
        // 是否新能源
        isNewEnergy() {
            return this.commonCard == 2;
        },
        // 是否启用数组键盘
        isNum() {
            return this.activeKeyWordIndex != 1;
        },
        // 最大输入个数
        maxLength() {
            return this.isNewEnergy ? 8 : 7;
        }
    },
    methods: {
        checkValue() {
            const me = this,
                license = me.numArr.join("");
            // 标识当前是内部值改变状态
            me.isChange = true;
            // 双向绑定数据处理
            me.$emit("update", license);
            // 验证车牌
            me.isverify = me.validLicense(license);
            // 抛出事件
            me.$emit("verifyChange", me.isverify);
            // 延时处理，重置标识
            setTimeout(() => {
                me.isChange = false;
            }, 50);
        },
        // 验证车牌
        validLicense(license) {
            const me = this;
            // 验证长度
            let length = 7,
                // 校验车牌号码
                reg = me.oldRegular,
                is;
            // 新能源校验规则
            if (me.isNewEnergy) {
                reg = me.newRegular;
                length = 8;
            }
            is = reg.test(license);
            if (is) {
                // 验证车牌长度
                is = license.length == length;
            }
            console.log("车牌号:", license, ",校验结果:", is);
            return is;
        },
        setKeyValue(v, index) {
            const list = this.numArr;
            list[index] = v;
            // 赋值
            this.numArr = Object.assign([], list);
        },
        clickKeyBoard(v, is) {
            if (is) {
                // 获取已输入项和当前选中位置
                const selectInputIndex = this.activeKeyWordIndex;
                this.setKeyValue(v, selectInputIndex);
                // 选中一个后，下一个输入框聚焦
                this.activeKeyWordIndex =
                    selectInputIndex !== this.maxLength - 1
                        ? selectInputIndex + 1
                        : selectInputIndex;
            }
        },
        deleteWord() {
            // 获取已输入项和当前选中位置
            const selectInputIndex = this.activeKeyWordIndex;
            this.setKeyValue("", selectInputIndex);
            this.activeKeyWordIndex = !this.isText
                ? selectInputIndex - 1
                : selectInputIndex;
        },
        // 点击输入框
        inputCarNum(v) {
            this.isKeyBoard = true;
            this.activeKeyWordIndex = v;
        },
        // 隐藏键盘
        hidden() {
            this.isKeyBoard = false;
        },
        // 设置值
        setValue(v) {
            const me = this,
                value = me.value;
            // 如果当前是内部改变值，不做处理
            if (!me.isChange) {
                let list = ["", "", "", "", "", "", "", ""];
                if (value) {
                    list = value.split("");
                    me.commonCard = value.length == 8 ? "2" : "1";
                }
                me.numArr = list;
            }
        }
    },
    created() {
        const me = this,
            value = me.value;
        if (value) {
            me.setValue(value);
        }
        // 全局新增点击事件监听，点击其他区域时隐藏键盘弹窗
        document.addEventListener("click", me.hidden, false);
    },

    beforeDestroy() {
        // 销毁监听事件
        document.removeEventListener("click", this.hidden, false);
    }
};
</script>
<style lang="scss" scoped>
.btn-keyboard {
    width: 64px;
    height: 80px;
    margin: 10px 5px;
    box-shadow: 0px 2px 2px 0px rgba(66, 66, 67, 0.5);
}
.license-wrap {
    .radio-box {
        margin-bottom: 40px;
        color: #666666;
        input[type="radio"] {
            display: none;
        }
        label {
            padding-left: 20px;
            cursor: pointer;
            img {
                width: 30px;
                margin-right: 4px;
            }
        }
    }
    // input输入框
    .num-box {
        .van-button {
            line-height: normal;
        }
        .spot {
            width: 6px;
            height: 6px;
            margin: 0 10px;
            background-color: #d8d8d8;
        }
        .btn-num {
            font-size: 30px;
            padding: 0;
            width: 75px;
            height: 75px;
            box-shadow: 0px 5px 5px 0px rgba(194, 182, 183, 0.2);
            &.select {
                border: 1px solid rgba(255, 154, 43, 1);
            }
        }
    }
}

//键盘
.keyboard-license-wrap {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 1000;
    background-color: rgba(217, 217, 217, 1);
    width: 100%;
    height: 520px;
    .btn-keyWin {
        margin: 9px 10px 10px;
        width: 731px;
        height: 80px;
        background-color: #fff;
        background-image: url("~@/assets/imges/ico/down.png");
        background-repeat: no-repeat;
        background-size: 5%;
    }
    .delete {
        @include bg(50px);
        width: 160px;
        height: 80px;
        background-image: url("~@/assets/ux/license/del.png");
    }
    .letter-container {
        .btn-keyboard {
            .van-button__text {
                font-size: 38px;
            }
        }
    }
}
[data-theme="app"] {
    .license-wrap {
        // input输入框
        .num-box {
            .btn-num {
                &.select {
                    border: 1px solid #c30d23;
                }
            }
        }
    }
}
</style>
